var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.162,
    height: 10.393,
    viewBox: "0 0 13.162 10.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M118.949,832.635l-1.995-1.69-1.509-1.282-1.485-1.257a2.251,2.251,0,0,0-2.744,0l-4.988,4.229a.573.573,0,0,0,0,.9.855.855,0,0,0,1.067,0l4.988-4.229a.51.51,0,0,1,.61,0l4.988,4.229a.855.855,0,0,0,1.067,0,.574.574,0,0,0,0-.9Zm-6.1-2.109a.416.416,0,0,0-.524,0l-4.387,3.717a.292.292,0,0,0-.108.222v2.712a1.269,1.269,0,0,0,1.359,1.153h2.172v-2.851h2.452v2.851h2.172a1.268,1.268,0,0,0,1.359-1.153v-2.712a.291.291,0,0,0-.108-.222Z",
    transform: "translate(-106.007 -827.94)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalContract);
export default __webpack_public_path__ + "static/media/localContract.9d78bdda.svg";
export { ForwardRef as ReactComponent };